<template>
  <div
    v-if="hasRole('employee', 'ROLE_POST_EMPLOYEE') || hasRole('company', 'ROLE_POST_COMPANY_ID_EMPLOYEE_UPLOAD')"
    class="employee-button"
  >
    <v-menu offset-y right>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          color="warning--gradient"
          :rounded="hasMainMenuOpen || isMobileDevice"
          :block="hasMainMenuOpen || isMobileDevice"
          :depressed="hasMainMenuOpen || isMobileDevice"
          :large="hasMainMenuOpen || isMobileDevice"
          :fab="!hasMainMenuOpen && !isMobileDevice"
          @click="handleHasCompanySelected"
        >
          <img v-if="!hasMainMenuOpen && !isMobileDevice" src="./ico_phone-call.svg" :alt="$t(`${namespace}.buttonLabel`)">
          <span v-if="hasMainMenuOpen || isMobileDevice">{{ $t(`${namespace}.buttonLabel`) }}</span>
          <v-icon v-if="hasMainMenuOpen || isMobileDevice" right small>keyboard_arrow_down</v-icon>
        </v-btn>
      </template>

      <v-list v-if="selectedCompany">
        <v-list-item
          v-if="$route.name !== 'Employee' && hasRole('employee', 'ROLE_POST_EMPLOYEE')"
          @click="$router.push({ name: 'Employee', params: { type: 'cadastrar' } })"
        >
          <v-list-item-title>{{ $t(`${namespace}.addEmployee`) }}</v-list-item-title>
        </v-list-item>

        <v-list-item
          v-if="hasRole('company', 'ROLE_POST_COMPANY_ID_EMPLOYEE_UPLOAD')"
          @click="$router.push({ name: 'EmployeeBulkOperation' })"
        >
          <v-list-item-title>{{ $t(`${namespace}.addCollaboratorsBulk`) }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { hasRole } from 'utils/functions'
import mediaQueries from 'mixins/mediaQueries'

export default {
  name: 'EmployeeButton',
  mixins: [mediaQueries],
  computed: {
    ...mapState({
      hasMainMenuOpen: ({ mainMenu }) => mainMenu.isOpen,
      selectedCompany: ({ company }) => company.selectedCompany
    }),

    isMobileDevice () {
      return this.isMobile || this.isTablet
    }
  },
  data () {
    return {
      namespace: 'Components.EmployeeButton'
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    hasRole (group, role) {
      return hasRole(group, role)
    },

    handleHasCompanySelected () {
      if (!this.selectedCompany) {
        this.showAlert({
          type: 'info',
          message: this.$t(`${this.namespace}.companyNotSelected`)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.employee-button {
  padding: 0 12px;

  .v-btn--fab.v-size--default {
    height: 44px;
    width: 44px;
  }
}
</style>
